import { testFbAuth, testFbId } from './index'

/**
 *
 * PROCESS DUTIES
 *
 */

export const rgxFirebaseKey = /(([A-Za-z0-9\-_]){10,256})+/

// export const rgxFirebaseKey = /(([A-Za-z0-9\-\_]){10,256})+/

//
// ?
//

export const apiGetCurrentUser = () => {
  return !!testFbAuth === true && !!testFbAuth.currentUser === true ? testFbAuth.currentUser : false
}

//
// USADO SOMENTE NO duties.js
//

export const apiGetUserId = () => {
  const requesterSession = apiGetCurrentUser()
  return !!requesterSession === true ? requesterSession.uid : false
}

export const apiIsUserAdmin = async (userID, groupID) => {
  const snapshot = await testFbId.ref('users/' + userID + '/grupos/' + groupID + '/admin').once('value')
  return (snapshot && snapshot.val()) ? snapshot.val() : false
}

/**
 *
 * FUNCTIONS
 *
 */

export const apiGenerateEntityID = path => {
  const entityKey = testFbId.ref(path).push().key
  return entityKey
}

export const apiGetScaleRef = (groupID, scaleID) => {
  return testFbId.ref('escalas/' + groupID + '/' + scaleID)
}

export const apiGetScale = async (groupID, scaleID) => {
  const snapshot = await testFbId.ref('escalas/' + groupID + '/' + scaleID).once('value')
  return snapshot && snapshot.val() ? snapshot.val() : false
}

/**
 *
 * RelatorioHoras.vue
 *
 */

export const apiRefOpen = (ref, callback) => {
  ref.on('value', callback)
}

export const apiRefClose = (ref, callback) => {
  ref.off('value', callback)
}

export const fbFullUpdate = object => {
  return new Promise((resolve, reject) => {
    //
    // ATUALIZA DADOS NO BANCO

    try {
      testFbId.ref().update(object,
      error => {
        if (error) {
          resolve({
            code: 0,
            response: '',
            error,
          })
        } else {
          resolve({
            code: 1,
            response: '',
            error: '',
          })
        }
      })
    } catch (e) {
      resolve({
        code: 0,
        response: '',
        error: e,
      })
    }
  })
}

export const getScalesByGroupID = groupID => {
  return new Promise((resolve, reject) => {
    testFbId.ref(`escalas/${groupID}`).once('value').then(snapshot => {
      resolve(snapshot && snapshot.exists() ? Object.entries(snapshot.val()) : [])
    })
    .catch((e) => {
      resolve([])
    })
  })
}

export const getScaleByID = async (groupID, scaleID) => {
  const request = await testFbId.ref(`escalas/${groupID}/${scaleID}`).once('value')
  return (request && request.val()) ? request.val() : false
}

export const getGroupByID = async groupID => {
  const groupRequest = await testFbId.ref(`grupos/${groupID}`).once('value')
  return (groupRequest && groupRequest.val()) ? groupRequest.val() : false
}

export const getUserByID = async userID => {
  const userRequest = await testFbId.ref(`users/${userID}`).once('value')
  const user = (userRequest && userRequest.val()) ? userRequest.val() : false

  if (user && typeof user === 'object')
  {
    user.uid = userID
    // user.userID = userID // DO APP
    // user.admin = !!group.users[userID].admin // DO APP
  }

  return user
}

export const getPatientByID = async patientId => {
  const patientRequest = await testFbId.ref(`pacientesportal/${patientId}`).once('value')
  const patient = (patientRequest && patientRequest.val()) ? patientRequest.val() : false

  if (patient && typeof patient === 'object') patient.patientId = patientId

  return patient
}

export const getUserByUserID = async userID => {
  const userRequest = await testFbId.ref(`users/${userID}`).once('value')
  const user = (userRequest && userRequest.val()) ? userRequest.val() : false
  return (user && typeof user === 'object') ? user : false
}

export const apiGetUserDetails = async (userID, nameMaxLength = 12) => {
  const request = await testFbId.ref(`users/${userID}`).once('value')
  const result = (request && request.val()) ? request.val() : false
  const user = (result && typeof result === 'object') ? result : false

  if (!!user === false) return false

  // && !!eventOwner.nome && eventOwner.nome.trim().length > 0 ? eventOwner.nome.trim() :
  // userImage: !!eventOwner && !!eventOwner.img && this.isValidGroupImage(eventOwner.img) ? eventOwner.img : this.userProfileBroken,

  const isValidImage = !!user && !!user.img && typeof user.img === 'string' && user.img.indexOf('https://firebasestorage.googleapis.com/') !== -1
  const userName = !!user && !!user.nome === true && user.nome.trim().length > 0 ? user.nome.trim() : ''

  return {
    ...user,
    img: isValidImage ? user.img : '',
    nome: userName,
    userID,
    // Limita o tamanho de nomes
    shortName: userName.length > nameMaxLength ? `${userName.substr(0, nameMaxLength)}...` : userName,
  }
}
